import * as React from 'react';

import {CloseButton} from 'shells/button/close-button/close-button';
import {Popover} from 'shells/popover/popover';
import {Title} from 'shells/typography/title';

import styles from './unlock-error.module.css';

type Props = {
    title: string;
    info: React.ReactNode;
    onClose: () => void;
    anchor: HTMLElement;
};

export function UnlockError(props: Props) {
    return (
        <Popover anchor={props.anchor} onBlur={props.onClose} location='top'>
            <div className={styles.content}>
                <div className={styles.top}>
                    <Title>{props.title}</Title>
                    <CloseButton onClick={props.onClose} />
                </div>
                <div className={styles.info}>{props.info}</div>
            </div>
        </Popover>
    );
}
